module.exports = __webpack_public_path__ + "static/media/sse.86e4d9ad.png";